import { createAptAPI, getRoadAddrSearchAPI } from "@/apis/admin-api"
import { useState } from "react"
import { toast } from "sonner"
import { adminAptStore } from "../admin-apt-store"
import CreateLabel from "../../_components/create-form/create-label"
import CreateInput from "../../_components/create-form/create-input"
import CreateButton from "../../_components/create-form/create-button"
import CreateSelect from "../../_components/create-form/create-select"
import Wrapper from "@/components/wrapper"

const HEAT_OPTIONS = [
  { value: 0, label: "지역 난방" },
  { value: 1, label: "개별 난방" }
]

const CreateAptForm = ({ successAction }) => {
  const { apiAction } = adminAptStore()

  const [aptForm, setAptForm] = useState({
    road_addr: "",
    kapt_code: "",
    region_key: "",
    apt_name: "",
    move_in_date: "",
    heat_type: 0
  })

  const doroAddrSearch = async (road_addr) => {
    const splitRoadAddr = road_addr.trim().split(" ")

    if (splitRoadAddr.length < 3) {
      return toast.error("정확한 도로명 주소를 입력해 주세요.")
    }

    const isRoadNumber = splitRoadAddr[splitRoadAddr.length - 1]

    if (/^\d+(-\d+)?$/.test(isRoadNumber)) {
      splitRoadAddr.pop()
    }

    const sido = splitRoadAddr.shift()
    const road = splitRoadAddr.pop()

    let sgg = splitRoadAddr.length === 1 ? splitRoadAddr[0] : splitRoadAddr.join(" ")

    if (sido === "세종특별자치시") {
      sgg = "세종시"
    }

    const result = await getRoadAddrSearchAPI({
      sido,
      sgg,
      road
    })
    return result
  }

  const changeDirect = (value, key) => {
    setAptForm((prev) => ({
      ...prev,
      [key]: value
    }))
  }

  const createApt = async () => {
    const { road_addr, kapt_code, region_key, apt_name, move_in_date, heat_type } = aptForm

    if (!kapt_code) return toast.error("아파트 코드를 입력해 주세요.")

    if (!apt_name) return toast.error("아파트 명을 입력해 주세요.")

    if (heat_type > 1) return toast.error("난방 타입은 0, 1로만 설정 가능합니다.")

    try {
      const { sgg_code, road_code } = await doroAddrSearch(road_addr)

      await createAptAPI({
        road_code,
        sgg_code,
        kapt_code: kapt_code.trim(),
        apt_name: apt_name.trim(),
        region_key: region_key.trim(),
        road_addr: road_addr.trim(),
        move_in_date: move_in_date || null,
        heat_type: heat_type || 0
      })

      toast.success(`${apt_name.trim()}이(가) 생성되었습니다.`)

      await apiAction()
      successAction?.()
    } catch (err) {
      if (err?.response?.status === 400) {
        toast.error(err.response.data.detail)
      }
    }
  }

  return (
    <div className="space-y-6 py-4 px-2">
      <div className="ml-2">
        <h2 className="text-lg font-bold text-slate-800">신규 아파트 등록</h2>

        <p className="mt-1 text-sm text-slate-500">
          <a
            href="https://www.k-apt.go.kr/"
            target="_blank"
            rel="noreferrer"
            className="
              relative
              text-blue-600
              font-medium

              after:absolute
              after:bottom-0
              after:left-0
              after:h-px
              after:w-0
              after:bg-blue-600
              after:transition-all

              hover:after:w-full
            "
          >
            K-APT
          </a>{" "}
          정보를 기반으로 신규 단지를 등록합니다.
        </p>
      </div>

      <Wrapper.shadow>
        <h3 className="mb-4 text-base font-semibold text-slate-800">아파트 정보 입력</h3>

        <div className="grid grid-cols-2 gap-5">
          <div>
            <CreateLabel label={"아파트명"} />

            <CreateInput
              placeholder="아파트명"
              value={aptForm.apt_name}
              onChange={(e) => changeDirect(e.target.value, "apt_name")}
            />
          </div>

          <div>
            <CreateLabel label={"도로명 주소"} />
            <CreateInput
              value={aptForm.road_addr}
              onChange={(e) => changeDirect(e.target.value, "road_addr")}
              placeholder="예) 서울특별시 종로구 삼일대로 428"
              className={"flex-1"}
            />
          </div>

          <div>
            <CreateLabel label={"K-APT 코드"} />

            <CreateInput
              placeholder="A10000000"
              value={aptForm.kapt_code}
              onChange={(e) => changeDirect(e.target.value, "kapt_code")}
            />
          </div>

          <div>
            <CreateLabel label={"지역키"} />

            <CreateInput
              placeholder="sejong"
              value={aptForm.region_key}
              onChange={(e) => changeDirect(e.target.value, "region_key")}
            />
          </div>

          <div>
            <CreateLabel label={"입주일"} />

            <CreateInput
              type="date"
              value={aptForm.move_in_date}
              onChange={(e) => changeDirect(e.target.value, "move_in_date")}
              min={"1900-01-01"}
              max={"9999-12-31"}
            />
          </div>

          <div>
            <CreateLabel label={"난방 타입"} />
            <CreateSelect
              value={aptForm.heat_type}
              options={HEAT_OPTIONS}
              onChange={(value) => changeDirect(value, "heat_type")}
            />
          </div>
        </div>

        <div className="mt-6 flex justify-end">
          <CreateButton onClick={createApt}>아파트 생성</CreateButton>
        </div>
      </Wrapper.shadow>
    </div>
  )
}

export default CreateAptForm
